const narrativeColumnLevels = [-1, 0, 1, 2];

export default narrativeColumnLevels;

export const labelForNarrativeColumnLevel = value => {
  switch (value) {
    case -1:
      return "Never";
    case 0:
      return "Level 1";
    case 1:
      return "Level 2";
    case 2:
      return "Level 3";
  }
};

export const shortLabelForNarrativeColumnLevel = value => {
  switch (value) {
    case -1:
      return "0";
    case 0:
      return "1";
    case 1:
      return "2";
    case 2:
      return "3";
  }
};

export const descriptionForNarrativeColumnLevel = value => {
  switch (value) {
    case -1:
      return "Arrange items vertically in a single column.";
    case 0:
      return "Arrange top level items horizontally.";
    case 1:
      return "Arrange the top 2 levels of items horizontally.";
    case 2:
      return "Arrange the top 3 levels of items horizontally.";
  }
};
